import React, { useState, useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "components/Navbar";
import Sidebar from "components/Sidebar";
import { fetchWebsiteProfile } from "state/userActions";

const Layout = () => {
  const isNonMobile = useMediaQuery("(min-width: 900px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.user.accessToken);

  // Segarkan permission user setiap halaman dimuat,
  // agar perubahan role langsung terlihat tanpa login ulang
  useEffect(() => {
    if (accessToken) {
      dispatch(fetchWebsiteProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%">
      <Sidebar
        isNonMobile={isNonMobile}
        drawerWidth="250px"
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <Box flexGrow={1} minWidth={0} sx={{ backgroundColor: "background.default", minHeight: "100vh" }}>
        <Navbar
          // user={data || {}}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
